import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import type { PublicHealthStepParams } from './types'
import { incomeSchema } from './types'

export const income = (params: PublicHealthStepParams) => {
  const schema = incomeSchema
  return {
    schema,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_publicHealth:steps.income.title',
        },
      },
      {
        type: 'choice',
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_publicHealth:steps.income.options.less_than_30k',
            },
            value: 'less_than_30k',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_publicHealth:steps.income.options.30k_to_50k',
            },
            value: '30k_to_50k',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_publicHealth:steps.income.options.50k_to_74k',
            },
            value: '50k_to_74k',
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_publicHealth:steps.income.options.more_than_74k',
            },
            value: 'more_than_74k',
          },
        ],
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('income'),
      },
    ],
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },
    nextStep: 'include_kids',
    subFlow: SubFlow.PublicHealth,
  } as const satisfies AnyStepConfiguration
}
